import {distinct, siteList, merchantList, driverInfoList, getRegionTree, selectMerchantForFinance } from '@/api/common'

const selectTreeMixins = {
  data() {
    return {
      items: [],
      areaLevelItems: []
    }
  },
  methods: {
    getAreaItem() {
      // areaSelect().then(resp => {
      //   this.items = handleSelectTree(resp.data)
      // })
      distinct().then(resp => {
        const data = resp.children.filter(p => p.name === '云南省' || p.name === '四川省')
        this.items = data
      })
    },
    getRegions() {
      getRegionTree().then(({code, data}) => {
        if (code === 0) {
          this.areaLevelItems = data
        }
      })
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.getAreaItem()
      this.getRegions()
    })
  }
}

// 查询下拉
const querySelectDicMixins = {
  data() {
    return {
      siteDic: [], // 站点
      merchantDic: [], // 供应商
      driverDic: [], // 司机信息
      merchantListDic:[] //下拉供应商
    }
  },
  methods: {
    // 获取站点列表
    getSiteList() {
      siteList().then(resp => {
        this.siteDic = resp.data
      })
    },

    getMerchantList() {
      merchantList().then(resp => {
        this.merchantDic = resp.data
      })
    },

    getDriverInfoList() {
      driverInfoList().then(resp => {
        this.driverDic = resp.data
      })
    },
    getMerchantForFinance(){
      selectMerchantForFinance().then(res=> {
        this.merchantListDic = res.data
      }).catch(error=> {
        this.$message.error(error)
      })
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.getSiteList()
      this.getMerchantList()
      this.getDriverInfoList()
      this.getMerchantForFinance()
    })
  }
}

export { selectTreeMixins, querySelectDicMixins }
